// extracted by mini-css-extract-plugin
export default {"card":"CardBook_card__X2bUt","img-size":"CardBook_img-size__uwFHh"};